import { render, staticRenderFns } from "./PropertyRealEstateFieldset.vue?vue&type=template&id=07d8c6cb&scoped=true"
import script from "./PropertyRealEstateFieldset.vue?vue&type=script&lang=js"
export * from "./PropertyRealEstateFieldset.vue?vue&type=script&lang=js"
import style0 from "./PropertyRealEstateFieldset.vue?vue&type=style&index=0&id=07d8c6cb&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07d8c6cb",
  null
  
)

export default component.exports